import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { HeaderComponent, NavigationItem } from '../../components/header/header.component';
import { ScrollToTopComponent } from '../scroll-to-top/scroll-to-top.component';
import { ToastContainerComponent } from '../toast/toast-container.component';

@Component({
    selector: 'pax-admin-shell',
    templateUrl: './admin-shell.component.html',
    standalone: true,
    imports: [HeaderComponent, ScrollToTopComponent, RouterOutlet, ToastContainerComponent],
})
export class AdminShellComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly translateService = inject(TranslateService);
    navigationItems = signal<NavigationItem[]>([]);

    get isAuthRoute(): boolean {
        return this.router.url.includes('auth');
    }

    async ngOnInit(): Promise<void> {
        await lastValueFrom(this.translateService.use('de'));
        this.navigationItems.set([
            {
                label: this.translateService.instant('admin.navigation.home'),

                path: '/conf/home',
            },
            {
                label: this.translateService.instant('admin.navigation.messenger'),
                path: '/conf/messenger',
            },
            {
                label: this.translateService.instant('admin.navigation.feedbacks'),
                path: '/conf/feedback',
            },
            {
                label: this.translateService.instant('admin.navigation.systemNotifications'),
                path: '/conf/system-notifications',
            },
            {
                label: this.translateService.instant('admin.navigation.cronjobs'),
                path: '/conf/cronjobs',
            },
            {
                label: this.translateService.instant('admin.navigation.resetRegistration'),
                path: '/conf/reset-registration',
            },
        ]);
    }
}
